// extracted by mini-css-extract-plugin
module.exports = {"header":"Modal_header__2iKxm","groupButtons":"Modal_groupButtons__1dfVE","button":"Modal_button__2Kbva","closeIcon":"Modal_closeIcon__3K4C5"};